<template>
  <div class="missions__header">
    <h4 class="missions__label">{{ $t("missions.list.header") }}</h4>
    <MissionsTimer />
    <!-- <div class="missions__switch">
      <i
        class="icon icon-cards gtm-view-card"
        :class="{ active: viewType === 'decor' }"
        @click="setView('decor')"
      ></i>
      <i
        class="icon icon-list gtm-view-table"
        :class="{ active: viewType === 'table' }"
        @click="setView('table')"
      ></i>
    </div> -->
  </div>
</template>
<script>
import MissionsTimer from "./MissionsTimer";
export default {
  name: "MissionListHeader",
  components: {
    MissionsTimer,
  },
  props: {
    viewType: String,
  },
  methods: {
    setView(type) {
      this.$emit("setViewContent", type);
    },
  },
};
</script>
